import React, { useEffect, useState } from 'react'
import styles from './styles.module.scss'

import { titleData } from '../../../data/titles'
import { contactPreferencesData } from '../../../data/contactPreferences'
import {
    InputFieldText,
    InputFieldSelect,
    FieldGroup,
    Field,
    SubmitButton,
    ButtonContainer,
    FieldContainer,
    FormCard,
} from '../../reusable'

import { FormPartInterface, SaveValueInterface } from '../../../interfaces'
import { InputFieldAddressLookup } from '../../reusable/inputFieldAddressLookup'
import { sectionValidation } from '../../../helpers'
import { getWidth } from '../../../helpers/screenWidth'
import { useClaimData, useUpdateClaimData } from '../../../claimProvider'
import { checkCounties } from '../../../data/counties'

export const AddressDetails = (props: FormPartInterface) => {
    const { saveValueFunct, isActive, assignGroup, validateSection, includePreviousAddressForm, EnhancedLabelText } =
        props
    const [currentStep, setCurrentStep] = useState(0)
    const [postCurrentStep, setPostCurrentStep] = useState(0)
    const [stepData, setStepData] = useState<any>({})
    const [showErrors, setShowErrors] = useState(false)
    const [errorMessage, setErrorMessage] = useState('')

    const [AddressText, setAddressText] = useState('')
    const [AddressOne, setAddressOne] = useState('')
    const [AddressTwo, setAddressTwo] = useState('')
    const [AddressThree, setAddressThree] = useState('')
    const [AddressTown, setAddressTown] = useState('')
    const [AddressCounty, setAddressCounty] = useState('')
    const [AddressPostcode, setAddressPostcode] = useState('')

    const claimData = useClaimData()
    const updateClaim = useUpdateClaimData()

    const [showPreviousAddressForm, setShowPreviousAddressForm] = useState(false)
    const [previousAddresses, setPreviousAddresses] = useState<any[]>([])
    const [currentEditingAddress, setCurrentEditingAddress] = useState<any>({
        text: '',
        line_one: '',
        line_two: '',
        line_three: '',
        town: '',
        county: '',
        postcode: '',
        house_number: '',
        flat_number: '',
    })
    const [editingIndex, setEditingIndex] = useState<number>(-1)
    const [showPrevAddressErrors, setShowPrevAddressErrors] = useState(false)

    const width = getWidth()
    const height = Number(width / 1.8).toFixed(0)

    const preSaveValueFunct = (dataToSave: SaveValueInterface) => {
        // console.log('DATA TO SAVE: ', dataToSave)

        if (dataToSave.field === 'searchAddress') {
            saveAddress(dataToSave.value)
            return { success: true, error: '' }
        }

        if (dataToSave.field === 'searchPreviousAddress') {
            savePreviousAddress(dataToSave.value)
            return { success: true, error: '' }
        }

        switch (dataToSave.field) {
            case 'address_line_one':
                setAddressOne(dataToSave.value)
                break
            case 'address_line_two':
                setAddressTwo(dataToSave.value)
                break
            case 'address_line_three':
                setAddressThree(dataToSave.value)
                break
            case 'city':
                setAddressTown(dataToSave.value)
                break
            case 'county':
                setAddressCounty(dataToSave.value)
                break
            case 'postcode':
                setAddressPostcode(dataToSave.value)
                break

            case 'prev_address_line_one':
                setCurrentEditingAddress((prev: any) => ({ ...prev, line_one: dataToSave.value }))
                break
            case 'prev_address_line_two':
                setCurrentEditingAddress((prev: any) => ({ ...prev, line_two: dataToSave.value }))
                break
            case 'prev_address_line_three':
                setCurrentEditingAddress((prev: any) => ({ ...prev, line_three: dataToSave.value }))
                break
            case 'prev_city':
                setCurrentEditingAddress((prev: any) => ({ ...prev, town: dataToSave.value }))
                break
            case 'prev_county':
                setCurrentEditingAddress((prev: any) => ({ ...prev, county: dataToSave.value }))
                break
            case 'prev_postcode':
                setCurrentEditingAddress((prev: any) => ({ ...prev, postcode: dataToSave.value }))
                break
            default:
                break
        }

        const saved = saveValueFunct(dataToSave)
        // setStepData((prevData: Record<string, any>) => ({
        //     ...prevData,
        //     [dataToSave.field]: dataToSave.value,
        // }))
        return { success: true, error: '' }
    }

    const saveAddress = (addressString: string) => {
        setAddressText('')
        setAddressOne('')
        setAddressTwo('')
        setAddressThree('')
        setAddressTown('')
        setAddressCounty('')
        setAddressPostcode('')

        updateClaim({
            ...claimData,
            address_line_one: '',
            address_line_two: '',
            address_line_three: '',
            city: '',
            county: '',
            postcode: '',
        })

        // saveValueFunct({ field: 'address_line_one', value: '' })
        // saveValueFunct({ field: 'address_line_two', value: '' })
        // saveValueFunct({ field: 'address_line_three', value: '' })
        // saveValueFunct({ field: 'city', value: '' })
        // saveValueFunct({ field: 'county', value: '' })
        // saveValueFunct({ field: 'postcode', value: '' })

        setAddressText(addressString)
        const addressArr = addressString.split(', ')

        const lineOne = addressArr[0] || ''
        const lineTwo = addressArr.length > 3 ? addressArr[1] || '' : ''
        const lineThree = addressArr.length > 4 ? addressArr[addressArr.length - 3] || '' : ''
        const town = addressArr[addressArr.length - 2] || ''
        const county = addressArr[addressArr.length - 1] || ''
        const postcode = addressArr[addressArr.length - 1] || ''

        setAddressOne(lineOne)
        setAddressTwo(lineTwo)
        setAddressThree(lineThree)
        setAddressTown(town)
        setAddressCounty(county)
        setAddressPostcode(postcode)
        // saveValueFunct({ field: 'address_line_one', value: lineOne })
        // saveValueFunct({ field: 'address_line_two', value: lineTwo })
        // saveValueFunct({ field: 'address_line_three', value: lineThree })
        // saveValueFunct({ field: 'city', value: town })
        // saveValueFunct({ field: 'county', value: county })
        // saveValueFunct({ field: 'postcode', value: postcode })

        updateClaim({
            ...claimData,
            address_line_one: lineOne,
            address_line_two: lineTwo,
            address_line_three: lineThree,
            city: town,
            county: county,
            postcode: postcode,
        })

        console.log('STEP DATA: ', stepData)
        setStepData((prevData: Record<string, any>) => ({
            ...prevData,
            address_line_one: lineOne,
            address_line_two: lineTwo,
            address_line_three: lineThree,
            city: town,
            county: county,
            postcode: postcode,
        }))
    }

    const savePreviousAddress = (addressString: string) => {
        console.log('Saving previous address:', addressString)

        setCurrentEditingAddress({
            text: '',
            line_one: '',
            line_two: '',
            line_three: '',
            town: '',
            county: '',
            postcode: '',
            house_number: '',
            flat_number: '',
        })

        const addressArr = addressString.split(', ')
        console.log('Address array:', addressArr)

        const firstLine = addressArr[0] || ''
        const houseNumberMatch = firstLine.match(/^(\d+)\s+(.+)$/)
        const flatNumberMatch = firstLine.match(/^Flat\s+(\d+[A-Za-z]?)\s+(.+)$/i)

        let lineOne = firstLine
        let houseNumber = ''
        let flatNumber = ''

        if (flatNumberMatch) {
            flatNumber = flatNumberMatch[1]
            lineOne = `Flat ${flatNumber} ${flatNumberMatch[2]}`
        } else if (houseNumberMatch) {
            houseNumber = houseNumberMatch[1]
            lineOne = `${houseNumber} ${houseNumberMatch[2]}`
        }

        let county = ''
        if (addressArr[0] != '') {
            let countyText = addressArr[addressArr.length - 2]
            county = checkCounties(countyText)
        }

        console.log('county', county)
        const postcode = addressArr[addressArr.length - 1] || ''
        let town = ''
        let lineTwo = ''
        let lineThree = ''

        if (county == '') {
            town = addressArr[addressArr.length - 2]
            if (town != addressArr[1]) {
                lineTwo = addressArr.length > 3 ? addressArr[1] || '' : ''
            }
            if (town != addressArr[2]) {
                lineThree = addressArr.length > 4 ? addressArr[2] || '' : ''
            }
        } else if (addressArr.length > 3) {
            town = addressArr[addressArr.length - 3]
            if (town != addressArr[1]) {
                lineTwo = addressArr.length > 3 ? addressArr[1].trim() || '' : ''
            }
            if (town != addressArr[2]) {
                lineThree = addressArr.length > 4 ? addressArr[2].trim() || '' : ''
            }
        }

        console.log('Parsed address parts:', {
            houseNumber,
            flatNumber,
            lineOne,
            lineTwo,
            lineThree,
            town,
            county,
            postcode,
        })

        setCurrentEditingAddress({
            text: addressString,
            house_number: houseNumber,
            flat_number: flatNumber,
            line_one: lineOne,
            line_two: lineTwo,
            line_three: lineThree,
            town: town,
            county: county,
            postcode: postcode,
        })
    }

    const handleShowPreviousAddressForm = () => {
        setCurrentEditingAddress({
            text: '',
            house_number: '',
            flat_number: '',
            line_one: '',
            line_two: '',
            line_three: '',
            town: '',
            county: '',
            postcode: '',
        })
        setEditingIndex(-1)
        setShowPreviousAddressForm(true)
        setShowPrevAddressErrors(false)
    }

    const handleCancelPreviousAddress = () => {
        setShowPreviousAddressForm(false)
        setCurrentEditingAddress({
            text: '',
            house_number: '',
            flat_number: '',
            line_one: '',
            line_two: '',
            line_three: '',
            town: '',
            county: '',
            postcode: '',
        })
        setEditingIndex(-1)
        setShowPrevAddressErrors(false)
    }

    const handleEditAddress = (index: number) => {
        const address = previousAddresses[index] as any
        setCurrentEditingAddress(address)
        setEditingIndex(index)
        setShowPreviousAddressForm(true)
        setShowPrevAddressErrors(false)
    }

    const handleDeleteAddress = (index: number) => {
        const updatedAddresses = previousAddresses.filter((_, i) => i !== index) as any
        setPreviousAddresses(updatedAddresses)

        saveValueFunct({ field: 'previous_addresses', value: JSON.stringify(updatedAddresses as any) })
        setStepData((prevData: Record<string, any>) => ({
            ...prevData,
            previous_addresses: updatedAddresses,
        }))
    }

    const handlePreviousAddressSubmit = () => {
        setShowPrevAddressErrors(true)
        setErrorMessage('')

        if (!currentEditingAddress.line_one || !currentEditingAddress.town || !currentEditingAddress.postcode) {
            setErrorMessage('Please fill in Address Line 1, City, and Postcode for your previous address.')
            return
        }

        let updatedAddresses: any[]
        if (editingIndex >= 0) {
            updatedAddresses = [...previousAddresses]
            updatedAddresses[editingIndex] = currentEditingAddress
        } else {
            updatedAddresses = [...previousAddresses, currentEditingAddress]
        }

        setPreviousAddresses(updatedAddresses)
        setShowPreviousAddressForm(false)
        setShowPrevAddressErrors(false)

        saveValueFunct({ field: 'previous_addresses', value: JSON.stringify(updatedAddresses) })

        setStepData((prevData: Record<string, any>) => ({
            ...prevData,
            previous_addresses: updatedAddresses,
        }))

        setCurrentEditingAddress({
            text: '',
            line_one: '',
            line_two: '',
            line_three: '',
            town: '',
            county: '',
            postcode: '',
            house_number: '',
            flat_number: '',
        })
        setEditingIndex(-1)
    }

    const animateBeforeAssign = (assignment: string) => {
        setShowErrors(true)
        if (!sectionValidation(stepData, 'address').success) return
        setTimeout(() => {
            assignGroup(assignment)
        }, 400)
    }

    const getCurrentStep = () => {
        return isActive === 'address' ? (
            <>
                <FieldGroup title="Address Information">
                    <FormCard assignPostStep={setPostCurrentStep} step={currentStep}>
                        <div
                            style={{
                                height: '100%',
                                overflowY: 'auto',
                            }}
                        >
                            <h3 style={{ marginTop: '0', marginBottom: '0' }}>Your Address</h3>
                            <p className={styles.description}>
                                {EnhancedLabelText
                                    ? EnhancedLabelText
                                    : 'Please enter your current address so we can send you important documents regarding your claim.'}
                            </p>
                            <Field extraStyle={{ padding: '0' }} fieldLabel="" labelPosition="left">
                                <InputFieldAddressLookup
                                    fieldName={`searchAddress`}
                                    saveValue={preSaveValueFunct}
                                    enhanced={true}
                                />
                            </Field>
                            {AddressText.length > 0 && (
                                <>
                                    <Field
                                        extraStyle={{ padding: '0' }}
                                        fieldLabel="Address Line 1"
                                        labelPosition="left"
                                    >
                                        <InputFieldText
                                            fieldName="address_line_one"
                                            saveValue={preSaveValueFunct}
                                            populateValue={AddressOne}
                                            enhanced={true}
                                            required={true}
                                            showErrors={showErrors}
                                        />
                                    </Field>
                                    {AddressTwo.length > 0 && (
                                        <Field
                                            extraStyle={{ padding: '0' }}
                                            fieldLabel="Address Line 2"
                                            labelPosition="left"
                                        >
                                            <InputFieldText
                                                fieldName="address_line_two"
                                                saveValue={preSaveValueFunct}
                                                populateValue={AddressTwo}
                                                enhanced={true}
                                            />
                                        </Field>
                                    )}
                                    {AddressThree.length > 0 && (
                                        <Field
                                            extraStyle={{ padding: '0' }}
                                            fieldLabel="Address Line 3"
                                            labelPosition="left"
                                        >
                                            <InputFieldText
                                                fieldName="address_line_three"
                                                saveValue={preSaveValueFunct}
                                                populateValue={AddressThree}
                                                enhanced={true}
                                            />
                                        </Field>
                                    )}
                                    <Field extraStyle={{ padding: '0' }} fieldLabel="City" labelPosition="left">
                                        <InputFieldText
                                            fieldName="city"
                                            saveValue={preSaveValueFunct}
                                            populateValue={AddressTown}
                                            enhanced={true}
                                            required={true}
                                            showErrors={showErrors}
                                        />
                                    </Field>
                                    <Field extraStyle={{ padding: '0' }} fieldLabel="Postcode" labelPosition="left">
                                        <InputFieldText
                                            fieldName="postcode"
                                            saveValue={preSaveValueFunct}
                                            populateValue={AddressPostcode}
                                            enhanced={true}
                                            required={true}
                                            showErrors={showErrors}
                                        />
                                    </Field>
                                    {includePreviousAddressForm && (
                                        <>
                                            <div
                                                style={{
                                                    marginTop: '30px',
                                                    marginBottom: '40px',
                                                    padding: '25px',
                                                    backgroundColor: '#f8f9fa',
                                                    borderRadius: '12px',
                                                    border: '2px solid #e9ecef',
                                                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                                                }}
                                            >
                                                <p
                                                    style={{
                                                        marginBottom: '20px',
                                                        fontSize: '16px',
                                                        color: '#333',
                                                        fontWeight: '500',
                                                    }}
                                                >
                                                    Have you lived at different addresses in the last 3 years?
                                                </p>

                                                {previousAddresses.length > 0 && (
                                                    <div style={{ marginBottom: '20px' }}>
                                                        <h4
                                                            style={{
                                                                fontSize: '16px',
                                                                marginBottom: '15px',
                                                                color: '#333',
                                                                fontWeight: '500',
                                                            }}
                                                        >
                                                            Previous Addresses:
                                                        </h4>
                                                        {previousAddresses.map((address, index) => (
                                                            <div
                                                                key={index}
                                                                style={{
                                                                    padding: '15px',
                                                                    backgroundColor: '#fff',
                                                                    border: '1px solid #dee2e6',
                                                                    borderRadius: '8px',
                                                                    marginBottom: '12px',
                                                                    fontSize: '14px',
                                                                }}
                                                            >
                                                                <div style={{ marginBottom: '5px' }}>
                                                                    {address.line_one}
                                                                    {address.line_two && `, ${address.line_two}`}
                                                                    {address.line_three && `, ${address.line_three}`}
                                                                </div>
                                                                <div style={{ color: '#666' }}>
                                                                    {address.town}, {address.postcode}
                                                                </div>
                                                                <div
                                                                    style={{
                                                                        marginTop: '12px',
                                                                        display: 'flex',
                                                                        gap: '15px',
                                                                    }}
                                                                >
                                                                    <button
                                                                        type="button"
                                                                        onClick={() => handleEditAddress(index)}
                                                                        style={{
                                                                            background: 'none',
                                                                            border: 'none',
                                                                            textDecoration: 'underline',
                                                                            cursor: 'pointer',
                                                                            fontSize: '14px',
                                                                            padding: '4px 8px',
                                                                            color: '#0d6efd',
                                                                            fontWeight: '500',
                                                                        }}
                                                                    >
                                                                        Edit
                                                                    </button>
                                                                    <button
                                                                        type="button"
                                                                        onClick={() => handleDeleteAddress(index)}
                                                                        style={{
                                                                            background: 'none',
                                                                            border: 'none',
                                                                            color: '#dc3545',
                                                                            textDecoration: 'underline',
                                                                            cursor: 'pointer',
                                                                            fontSize: '14px',
                                                                            padding: '4px 8px',
                                                                            fontWeight: '500',
                                                                        }}
                                                                    >
                                                                        Remove
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}

                                                {!showPreviousAddressForm && (
                                                    <button
                                                        type="button"
                                                        onClick={handleShowPreviousAddressForm}
                                                        style={{
                                                            background: '#c88f5f',
                                                            border: 'none',
                                                            borderRadius: '6px',
                                                            cursor: 'pointer',
                                                            fontSize: '15px',
                                                            padding: '12px 20px',
                                                            color: '#fff',
                                                            fontWeight: '500',
                                                        }}
                                                    >
                                                        {previousAddresses.length > 0
                                                            ? 'Add another previous address'
                                                            : 'Yes, add previous address'}
                                                    </button>
                                                )}
                                            </div>

                                            {showPreviousAddressForm && (
                                                <div
                                                    style={{
                                                        marginTop: '30px',
                                                        padding: '25px',
                                                        backgroundColor: '#f8f9fa',
                                                        borderRadius: '12px',
                                                        border: '2px solid #e9ecef',
                                                        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                                                    }}
                                                >
                                                    <h4
                                                        style={{
                                                            marginBottom: '20px',
                                                            color: '#333',
                                                            fontSize: '18px',
                                                            fontWeight: '500',
                                                        }}
                                                    >
                                                        {editingIndex >= 0
                                                            ? 'Edit Previous Address'
                                                            : 'Add Previous Address'}
                                                    </h4>
                                                    <p
                                                        style={{
                                                            marginBottom: '20px',
                                                            fontSize: '15px',
                                                            color: '#666',
                                                            lineHeight: '1.5',
                                                        }}
                                                    >
                                                        Please enter a previous address where you lived in the last 3
                                                        years.
                                                    </p>

                                                    {errorMessage && (
                                                        <div
                                                            style={{
                                                                marginBottom: '20px',
                                                                padding: '12px',
                                                                backgroundColor: '#fff3f3',
                                                                border: '1px solid #ffcdd2',
                                                                borderRadius: '6px',
                                                                color: '#dc3545',
                                                            }}
                                                        >
                                                            {errorMessage}
                                                        </div>
                                                    )}

                                                    <Field
                                                        extraStyle={{ padding: '0' }}
                                                        fieldLabel="Search Previous Address"
                                                        labelPosition="left"
                                                    >
                                                        <InputFieldAddressLookup
                                                            fieldName={`searchPreviousAddress`}
                                                            saveValue={preSaveValueFunct}
                                                            enhanced={true}
                                                        />
                                                    </Field>

                                                    {currentEditingAddress.text.length > 0 && (
                                                        <>
                                                            <Field
                                                                extraStyle={{ padding: '0' }}
                                                                fieldLabel="Address Line 1"
                                                                labelPosition="left"
                                                                enhanced={true}
                                                            >
                                                                <InputFieldText
                                                                    fieldName="prev_address_line_one"
                                                                    saveValue={preSaveValueFunct}
                                                                    populateValue={currentEditingAddress.line_one}
                                                                    enhanced={true}
                                                                    required={true}
                                                                    showErrors={showPrevAddressErrors}
                                                                />
                                                            </Field>
                                                            {currentEditingAddress.line_two.length > 0 && (
                                                                <Field
                                                                    extraStyle={{ padding: '0' }}
                                                                    fieldLabel="Address Line 2"
                                                                    labelPosition="left"
                                                                    enhanced={true}
                                                                >
                                                                    <InputFieldText
                                                                        fieldName="prev_address_line_two"
                                                                        saveValue={preSaveValueFunct}
                                                                        populateValue={currentEditingAddress.line_two}
                                                                        enhanced={true}
                                                                    />
                                                                </Field>
                                                            )}
                                                            {currentEditingAddress.line_three.length > 0 && (
                                                                <Field
                                                                    extraStyle={{ padding: '0' }}
                                                                    fieldLabel="Address Line 3"
                                                                    labelPosition="left"
                                                                    enhanced={true}
                                                                >
                                                                    <InputFieldText
                                                                        fieldName="prev_address_line_three"
                                                                        saveValue={preSaveValueFunct}
                                                                        populateValue={currentEditingAddress.line_three}
                                                                        enhanced={true}
                                                                    />
                                                                </Field>
                                                            )}
                                                            <Field
                                                                extraStyle={{ padding: '0' }}
                                                                fieldLabel="City"
                                                                labelPosition="left"
                                                                enhanced={true}
                                                            >
                                                                <InputFieldText
                                                                    fieldName="prev_city"
                                                                    saveValue={preSaveValueFunct}
                                                                    populateValue={currentEditingAddress.town}
                                                                    enhanced={true}
                                                                    required={true}
                                                                    showErrors={showPrevAddressErrors}
                                                                />
                                                            </Field>
                                                            <Field
                                                                extraStyle={{ padding: '0' }}
                                                                fieldLabel="Postcode"
                                                                labelPosition="left"
                                                                enhanced={true}
                                                            >
                                                                <InputFieldText
                                                                    fieldName="prev_postcode"
                                                                    saveValue={preSaveValueFunct}
                                                                    populateValue={currentEditingAddress.postcode}
                                                                    enhanced={true}
                                                                    required={true}
                                                                    showErrors={showPrevAddressErrors}
                                                                />
                                                            </Field>
                                                        </>
                                                    )}

                                                    <div
                                                        style={{
                                                            display: 'flex',
                                                            gap: '15px',
                                                            justifyContent: 'flex-end',
                                                            marginTop: '25px',
                                                        }}
                                                    >
                                                        <SubmitButton
                                                            text="Cancel"
                                                            btnType="secondary"
                                                            onClick={handleCancelPreviousAddress}
                                                        />
                                                        <SubmitButton
                                                            text={
                                                                editingIndex >= 0
                                                                    ? 'Update Address'
                                                                    : 'Save Previous Address'
                                                            }
                                                            btnType="primary"
                                                            onClick={handlePreviousAddressSubmit}
                                                        />
                                                    </div>
                                                </div>
                                            )}
                                        </>
                                    )}
                                </>
                            )}
                            <SubmitButton
                                text="Continue"
                                btnType="primary"
                                onClick={() => animateBeforeAssign('person')}
                            />
                        </div>
                    </FormCard>
                </FieldGroup>
            </>
        ) : (
            <></>
        )
    }

    return getCurrentStep()
}
